import { render, staticRenderFns } from "./businessAreaDetail.vue?vue&type=template&id=7ad368b2&scoped=true"
import script from "./businessAreaDetail.vue?vue&type=script&lang=js"
export * from "./businessAreaDetail.vue?vue&type=script&lang=js"
import style0 from "./businessAreaDetail.vue?vue&type=style&index=0&id=7ad368b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad368b2",
  null
  
)

export default component.exports